export default __webpack_public_path__ + "static/media/Dewey-Panic-Grass_R2.19aedd08.png";